import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SmsIcon from '@mui/icons-material/Sms';
import Grow from '@mui/material/Grow';
import CustomDialog from './CustomDialog';
import ConfirmDialog from './ConfirmDialog';

const TemplateMessageDialog = function TemplateMessageDialog({
  open = false,
  handleClose,
  handleSubmit,
  widgetWrapper,
  title = '',
  actions = null,
  submitDisabled = false,
  id,
}) {
  const [confirmClose, setConfirmClose] = useState(false);

  const handleOpenConfirmClose = () => {
    setConfirmClose(true);
  };
  const handleCloseConfirmClose = () => {
    setConfirmClose(false);
  };

  const handleConfirmClose = () => {
    setConfirmClose(false);
    handleClose();
  };

  return (
    <>
      <ConfirmDialog
        open={confirmClose}
        onCancel={handleCloseConfirmClose}
        onSubmit={handleConfirmClose}
        title="CONFIRM_CLOSE_SEND"
        question="CONFIRM_CLOSE_SEND_MESSAGE_DIALOG"
        fontSize="1.5rem"
      />
      <CustomDialog
        id={id}
        title={title}
        open={open}
        close={handleOpenConfirmClose}
        disableEscapeKeyDown
        notRequiredFields
        messageDialog
        styles={{
          minHeight: '8vh',
          content: {
            flexDirection: 'column',
          },
        }}
        maxWidth={id === 'massive-sms' ? 'lg' : 'md'}
        fullWidth
        icon={<SmsIcon />}
        transition={Grow}
        transitionDuration={600}
        onSubmit={handleSubmit}
        submitDisabled={submitDisabled}
        components={{ actions }}
        noBackdrop
      >
        {widgetWrapper}
      </CustomDialog>
    </>
  );
};

TemplateMessageDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  id: PropTypes.string.isRequired,
  widgetWrapper: PropTypes.object.isRequired,
  actions: PropTypes.object,
  submitDisabled: PropTypes.bool,
};

export default TemplateMessageDialog;
